// extracted by mini-css-extract-plugin
export var brand = "_1f-9";
export var compact = "_1f-6";
export var extraSmall = "_1f-7";
export var icon = "_1f-0";
export var large = "_1f-4";
export var light = "_1f-1";
export var medium = "_1f-5";
export var outline = "_1f-b";
export var primaryDark = "_1f-a";
export var primaryLight = "_1f-8";
export var primaryModern = "_1f-c";
export var success = "_1f-2";
export var successSolid = "_1f-3";